module.exports = __webpack_public_path__ + "media/theme/collection__reco-a8ecc186.png";